import { combineReducers } from 'redux';
import authReducer from './auth/authReducer';
import userReducer from './user/userReducer';
import socketReducer from './socket/socketReducer';
import configReducer from './config/configReducer';
import statusReducer from './status/statusReducer';
import metaReducer from './meta/metaReducer';
import settingReducer from "./settings/settingReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  socket: socketReducer,
  config: configReducer,
  status: statusReducer,
  meta: metaReducer,
  setting: settingReducer,
});

export default rootReducer;
